import type {
  DefecationEntity,
  DefecationPropsPub,
  DefecationPropsPvt,
} from './entity/defecationEntity';
import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';
import type { DefecationJsonPub, DefecationJsonPvt } from '@/types/domain/defecation/entities/defecationEntity';

import { DomainServiceBase } from '@/domain/domainServiceBase';

/**
 * 排泄物ドメインサービス(施設)
 */
export class DefecationNurseryDomainService extends DomainServiceBase {
  private wagakoNurseryApi!: WagakoNurseryIApi;

  /**
   * Injection
   * @param wagakoNurseryApi wagakoNurseryApi
   */
  public inject(
    wagakoNurseryApi: WagakoNurseryIApi,
  ) {
    this.wagakoNurseryApi = wagakoNurseryApi;
  }

  /**
   * sendNurseryDefecation
   * @param entity entity
   */
  async sendNurseryDefecation(
    entity: DefecationEntity,
  ) {
    await this.wagakoNurseryApi.send<
      DefecationPropsPvt,
      DefecationJsonPvt,
      DefecationPropsPub,
      DefecationJsonPub
    >(entity);
  }

  /**
   * removeNurseryDefecation
   * @param entity entity
   */
  async removeNurseryDefecation(
    entity: DefecationEntity,
  ) {
    await this.wagakoNurseryApi.remove<
      DefecationPropsPvt,
      DefecationJsonPvt,
      DefecationPropsPub,
      DefecationJsonPub
    >(entity);
  }
}
